import React from 'react';
import { useTranslation } from 'react-i18next';
import { Prefab } from '@ff-resource-plugins/prefabs-shared/Prefab';
import { PrefabPreviewMode } from '@ff-scene-plugins/gift-shared/GiftSceneOptions';
import classNames from 'classnames';
import { FullPrefabPreview2d } from './FullPrefabPreview2d';
import { MinimalPrefabPreview2d } from './MinimalPrefabPreview2d';
import styles from '../GiftPreviewUi.module.scss';

const modes = {
    'full': FullPrefabPreview2d,
    'minimal': MinimalPrefabPreview2d
};

export const PrefabPreview2d = ({ prefab, mode }: Props) => {
    const { t } = useTranslation();
    const Preview = modes[mode];
    return (
        <div className={classNames(styles.preview, styles[mode])}>
            <Preview prefab={prefab} t={t} />
        </div>
    );
};

type Props = {
    prefab: Prefab;
    mode: PrefabPreviewMode;
};